export function getWindowWidth() {
  return typeof window !== 'undefined' ? window.innerWidth : 0;
}
